// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.mjs";

function fromString(service) {
  var match = service.toLowerCase();
  switch (match) {
    case "helper" :
        return /* Helper */0;
    case "helper_labour" :
        return /* HelperAndLabour */1;
    default:
      return ErrorUtils$Catalyst.raiseError("ValueAddedService.res", "Invalid value added service", service);
  }
}

function toString(service) {
  if (service) {
    return "helper_labour";
  } else {
    return "helper";
  }
}

export {
  fromString ,
  toString ,
}
/* No side effect */
